// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'eg-section-header',
  standalone: false,
  templateUrl: './eg-section-header.component.html',
  styleUrl: './eg-section-header.component.css'
})
export class EgSectionHeaderComponent {
  @Input() title: string = '';
  @Input('navigateTo') navigateTo: string | undefined = undefined;

  constructor(private router: Router) { }

  goBack() {
    if (this.navigateTo) {
      this.router.navigate([this.navigateTo]);
      return;
    }
    this.router.navigate(['/']);
  }
}
